<span class="md-inputfield">
  <p-autoComplete
    name="autocomplete"
    field="nome"
    [style]="{'width':'100%'}"
    [inputStyle]="{'width':'100%'}"
    [(ngModel)]="autocomplete.itemSelecionado"
    [suggestions]="autocomplete.resultset"
    [dropdown]="true"
    [required]="obrigatorio"
    [disabled]="bloqueado || formDisabled"
    [size]="autocomplete.resultsetMaxSize"
    [forceSelection]="true"
    (completeMethod)="autocomplete.buscarItem($event)"
    (onSelect)="autocomplete.onSelectItem($event);"
    (onClear)="autocomplete.onClearItem()">
  </p-autoComplete>
  <label>{{placeholder}}</label>
</span>
